import Vue from 'vue';

Vue.component('vuetable-audit-trail', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './audit-trail-index.vue'),
);

Vue.component('audit-access-control', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './access-control/audit-access-control-index.vue'),
);

Vue.component('audit-product-master', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './product-master/audit-product-master-index.vue'),
);

Vue.component('audit-tax', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './tax/audit-tax-index.vue'),
);

Vue.component('audit-labels', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './labels/audit-label-index.vue'),
);

Vue.component('audit-fuel-price', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './fuel-price/audit-fuel-price-index.vue'),
);

Vue.component('audit-promotion', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './promotion/audit-promotion.index.vue'),
);

Vue.component('audit-main-pricebook', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './main-pricebook/audit-main-pricebook.index.vue'),
);

Vue.component('audit-station-pricebook', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './station-pricebook/audit-station-pricebook.index.vue'),
);
